import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import BackButtonLinkLight from "components/Common/buttons/BackButtonLinkLight";
import { statusFormatterWithMap } from "components/Common/formatter";
import { STATUS_COLOR_MAP } from "pages/price-management/Bundles/bundleDetails/constants";
import cylinder from "assets/images/svg/Gas Bottle.svg";
import price from "assets/images/svg/Price Tag.svg";
import timesheet from "assets/images/svg/Date To.svg";
import duration from "assets/images/svg/Timesheet.svg";
import time from "assets/images/svg/Time Span.svg";
import { TYPES_MAP } from "pages/price-management/Bundles/variables";

const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    backgroundColor: "#FFF",
    margin: -30,
    padding: "10px 30px",
    borderTop: "1px solid #0000001A",
  },
  imageContainer: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  rightContainer: {
    display: "flex",
    flex: 2,
    justifyContent: "space-between",
  },
  nameContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginLeft: 23,
  },
  titleName: {
    fontSize: 16,
    fontWeight: 600,
    marginRight: 7,
  },
  status: {
    color: "#FFFFFF",
    fontSize: 9,
    fontWeight: 300,
    backgroundColor: "#17C347",
    textTransform: "uppercase",
    padding: "3px 8px",
    borderRadius: 6,
    letterSpacing: "0.05em",
  },
  section: {
    display: "flex",
    alignItems: "center",
    flexGrow: 0.3,
    justifyContent: "flex-end",

    "& img": {
      width: 30,
      marginRight: -5,
    },
  },
  title: {
    color: "#666666",
    fontSize: 13,
    fontWeight: 300,

    "&>img": {
      height: 16,
    },
  },
  data: {
    fontSize: 13,
    fontWeight: 600,
    marginLeft: 5,
  },

  subTitle: {
    fontSize: 11,
    fontWeight: 300,
    color: "#8C8C8C",
  },
});

const Header = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.imageContainer}>
        <BackButtonLinkLight to="/price-management/bundles">Back</BackButtonLinkLight>

        <div className={classes.nameContainer}>
          <div>
            <span className={classes.titleName}>{data?.name}</span>
            {statusFormatterWithMap(data?.status, STATUS_COLOR_MAP)}
            <br />
            <span className={classes.subTitle}>Gas Bundle</span>
          </div>
        </div>
      </div>

      {data && (
        <div className={classes.rightContainer}>
          <div className={classes.section}>
            <div className={classes.title}>Type</div>
            <div className={classes.data} title={TYPES_MAP[data.type]}>
              {TYPES_MAP[data.type]}
            </div>
          </div>
          <div className={classes.section}>
            <div className={classes.title}>
              <img src={data.type === "TB" ? time : cylinder} alt="cylinder" />
            </div>
            <div className={classes.data} title={data.lpgOrTime}>
              {data.lpgOrTime}
            </div>
          </div>
          <div className={classes.section}>
            <div className={classes.title}>
              <img src={price} alt="price" />
            </div>
            <div className={classes.data} title={data.price}>
              {data.price}
            </div>
          </div>
          <div className={classes.section}>
            <div className={classes.title}>
              <img src={duration} alt="duration" />
            </div>
            <div className={classes.data} title={data.duration}>
              {data.validityPeriod}
            </div>
          </div>
          <div className={classes.section}>
            <div className={classes.title}>
              <img src={timesheet} alt="timesheet" />
            </div>
            <div
              className={classes.data}
              title={`${data.activationDate} / ${data?.deactivationDate ? data.deactivationDate : "-"}`}
            >
              {`${data.activationDate} / ${data?.deactivationDate ? data.deactivationDate : "-"}`}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
